package com.milta.feature.delivery.domain.usecase

import com.milta.feature.delivery.domain.entity.Delivery
import com.milta.feature.delivery.domain.repository.DeliveryRepository

class CreateDeliveryUseCase(private val repository: DeliveryRepository) {
    suspend operator fun invoke(
        routeId: String,
        recipientName: String?,
        address: String,
        phoneNumber: String?,
        deliveryTimeLimit: String?,
    ): Delivery = repository.createDelivery(
        routeId = routeId,
        recipientName = recipientName,
        address = address,
        phoneNumber = phoneNumber,
        deliveryTimeLimit = deliveryTimeLimit,
    )
}
